import React, { Component } from "react";
import { connect } from "react-redux";
import Editprofile from "../components/Editprofile";

import {
  UploadupdateLink,
  viewLinkById,
  setModalfalse,
} from "../../../adminActions";
import { close_snack_bar } from "../../../../../store/actions/snackbarActions";
export class Controller extends Component {
  render() {
    return <Editprofile {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    client: store.client,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    viewLinkById: (user_id, token) => {
      dispatch(viewLinkById(user_id, token));
    },

    UploadupdateLink: (
      token,
      user_id,
      id,
      Facebook,
      Instagram,
      WhatsApp,
      Browser,
      Snapchat,
      GoogleMaps,
      Twitter,
      LinkedIn,
      Telegram,
      YouTube,
      Pinterest,
      PDFDownloader,
      heading,
      mediaType,
      mobile,
      BusinessWhatsApp,
      Skype,
      massenger,
      wechat,
      FaceTime,
      coverImage,
      newcoverImage,
      profileImage,
      newprofileImage,
      showAllReviews,
      tagLine, login_id
    ) => {
      dispatch(
        UploadupdateLink(
          token,
          user_id,
          id,
          Facebook,
          Instagram,
          WhatsApp,
          Browser,
          Snapchat,
          GoogleMaps,
          Twitter,
          LinkedIn,
          Telegram,
          YouTube,
          Pinterest,
          PDFDownloader,
          heading,
          mediaType,
          mobile,
          BusinessWhatsApp,
          Skype,
          massenger,
          wechat,
          FaceTime,
          coverImage,
          newcoverImage,
          profileImage,
          newprofileImage,
          showAllReviews,
          tagLine, login_id
        )
      );
    },

    setModalfalse: () => {
      dispatch(setModalfalse());
    },
    close_snack_bar: () => {
      dispatch(close_snack_bar());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
